import { c as _c } from "react/compiler-runtime";
import { Item, ItemAvatar, ItemContent, ItemSide, ItemTitle } from "@opensea/next-ui-kit";
import { FlexCenter, FlexColumn, TextBody, Tooltip } from "@opensea/ui-kit";
import { BlurLogo, Bolt, CryptoPunksLogo } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { useSwapProtocols } from "@/components/currencies/activity/use-swap-protocols";
import { SWAP_PROTOCOLS } from "@/hooks/query-param/use-relayer-query-param";
export function AggregatorHoverable() {
  const $ = _c(6);
  const t = useTranslations("AggregatorHoverable");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MarketplacesContent />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Bolt size={16} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("aggregating");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Tooltip content={t0}><FlexCenter className="gap-1" color="text-secondary">{t1}<TextBody size="xs">{t2}</TextBody></FlexCenter></Tooltip>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}

// TODO: Fetch from BE
const marketplaces = [{
  text: "Blur",
  icon: BlurLogo
}, {
  text: "CryptoPunks",
  icon: CryptoPunksLogo
}];
function MarketplacesContent() {
  const $ = _c(13);
  const t = useTranslations("AggregatorHoverable");
  const {
    getName,
    getLogo
  } = useSwapProtocols();
  let t0;
  if ($[0] !== getLogo || $[1] !== getName) {
    const swapProtocols = SWAP_PROTOCOLS.map(identifier => ({
      text: getName(identifier),
      icon: getLogo(identifier)?.icon
    })).filter(_temp);
    t0 = [...swapProtocols, ...marketplaces];
    $[0] = getLogo;
    $[1] = getName;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const allProtocols = t0;
  let t1;
  if ($[3] !== t) {
    t1 = t("liquidityFrom");
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <div className="px-2 py-1.5">{t1}</div>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== allProtocols || $[8] !== t) {
    t3 = allProtocols.map((t4, idx) => {
      const {
        text,
        icon: Icon
      } = t4;
      return <Item className="px-2 py-1.5" key={`${text}-${idx}`} variant="unstyled"><ItemAvatar icon={Icon} size={20} /><ItemContent><ItemTitle>{text}</ItemTitle></ItemContent><ItemSide><ItemTitle className="rounded bg-success-1 bg-opacity-[0.08] px-1.5 py-0.5 text-success-1">{t("active")}</ItemTitle></ItemSide></Item>;
    });
    $[7] = allProtocols;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <FlexColumn className="w-[250px] font-sans">{t2}{t3}</FlexColumn>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
function _temp(protocol) {
  return protocol.icon && protocol.text;
}